<template>
  <div class="color-bar-wrap">
    <div>
      <i
        class="el-icon-location-outline"
        style="position: relative; bottom: -6px"
        :style="{ left: `calc(${percent}% - 8px)`, color: color }"
      ></i>
    </div>
    <canvas ref="bar" style="height: 10px" class="bar"></canvas>
    <div
      class="legend"
      :style="{
        'grid-template-columns': `repeat(auto-fill, ${100 / legendNumber}%)`,
      }"
    >
      <div v-for="(title, index) in legend" :key="index">
        <span :style="{ color: index == actionIndex ? color : '#666' }">{{
          title
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    percent: {
      default: 0,
    },
    legend: {
      default: function () {
        return ["较小风险", "中等风险", "较大风险", "风险大"];
      },
    },
    type: {
      default: "xiao",
    },
  },
  data() {
    return {
      color: "#666",
    };
  },
  computed: {
    //防止溢出
    percentCalc() {
      return this.percent == 100 ? 99 : this.percent;
    },
    legendNumber() {
      return this.legend.length;
    },
    actionIndex() {
      return Math.floor((this.legendNumber * this.percentCalc) / 100);
    },
    colorOffset() {
      if (this.type == "xiao") {
        return [
          {
            offset: 0,
            color: "#6ee277",
          },
          {
            offset: 1,
            color: "#039165",
          },
        ];
      } else {
        return [
          {
            offset: 0,
            color: "#eab544",
          },
          {
            offset: 1,
            color: "#eb2228",
          },
        ];
      }
    },
  },
  mounted() {
    this.setCanvas();
  },
  methods: {
    setCanvas() {
      this.$nextTick(() => {
        let canvas = this.$refs.bar;
        let context = canvas.getContext("2d");
        let gradient = context.createLinearGradient(0, 0, canvas.width, 0);

        this.colorOffset.forEach((item) => {
          gradient.addColorStop(item.offset, item.color);
        });

        context.fillStyle = gradient;
        context.fillRect(0, 0, canvas.width, canvas.width);

        let x = (canvas.width * this.percentCalc) / 100; // x 坐标
        let pixelData = context.getImageData(x, 4, 1, 1).data;

        let red = pixelData[0];
        let green = pixelData[1];
        let blue = pixelData[2];
        let alpha = pixelData[3];
        this.color = `rgba(${red}, ${green}, ${blue}, ${alpha})`;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.color-bar-wrap {
  .bar {
    width: 100%;
    border-radius: 5px;
  }
  .legend {
    text-align: center;
    display: grid;
    font-size: 12px;
  }
}
</style>